









import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import AbstractStep from '@modules/053-Raffle/components/AbstractStep.vue';
import ImageComponent from '@components/001-ImageComponent/ImageComponent.vue';
import IImage from '@frontend/types/base/IImage';

@Component({
	components: {
		ImageComponent
	}
})
export default class IntroStep extends AbstractStep {
	@Prop(Object)
	protected readonly image!: IImage;
}
